// tslint:disable
import {Service, service} from "./di";

// Branch.io integration service
@service
export class BranchService extends Service {
	constructor() {
		super();
		this.init();
	}

	init() {
		// @ts-ignore 
		(function(b, r, a, n, c, h, _, s, d, k){if (!b[n] || !b[n]._q){for (; s < _.length;)c(h, _[s++]); d = r.createElement(a); d.async = 1; d.src = "https://cdn.branch.io/branch-latest.min.js"; k = r.getElementsByTagName(a)[0]; k.parentNode.insertBefore(d, k); b[n] = h; }})(window, document, "script", "branch", function(b, r){b[r] = function(){b._q.push([r, arguments]); }; }, {_q: [], _v: 1}, "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);

		// @ts-ignore
		branch.init("key_live_ppOfQ7OzMmGfkwfsWRTsyekgqwkq3xxv");
	}

	sendSMS(number: string, options = {}) {
		const linkData = {
			channel: "Website",
			feature: "TextMeTheApp_FlyerBrowsing",
		};

		const callback = function(err: any) {
			if (err) {
				console.log("Something went worng");
				console.log(err);
			} else {
				console.log("SMS sent!");
			}
		};
			// @ts-ignore
		branch.sendSMS(number, linkData, options, callback);
	}
}
